export default function (Component) {
Component.options.__tip = "<p>If a component you put inside an <code>FdTableCell</code> subscribes to <code>@click</code>-events, you will most likely wand to use the <code>.stop</code>-modifier. Otherwise clicking a button will toggle the selection of the enclosing row.</p>\n"
}